import { default as BaseModal } from "@ds-developer/modal";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import Button from "@ds-developer/button";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import React from "react";

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

interface Props {
  lessonsNumber: number;
  closeModalHandler: () => void;
  handleSeeLessons: () => void;
  learnerId: string;
}

export const SuccessBookingModal: React.FC<Props> = ({
  lessonsNumber,
  closeModalHandler,
  handleSeeLessons,
  learnerId,
}) => {
  const classes = useStyles();
  const actions = (
    <>
      <Button variant="outlined" onClick={closeModalHandler}>
        Close
      </Button>
      <Button variant="contained" color="primary" onClick={handleSeeLessons}>
        <Link style={{ color: "#fff" }} to={`/learners/${learnerId}`}>
          See lessons
        </Link>
      </Button>
    </>
  );
  return (
    <BaseModal actions={actions} open={true} title="Booking successful ">
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={closeModalHandler}
      >
        <CloseIcon />
      </IconButton>
      <p>
        A block booking of <b>{lessonsNumber} lesson(s)</b> has been created.
      </p>
      <p>Click below to see the details of all lessons booked in this block.</p>
    </BaseModal>
  );
};
